export const SALES_RETURN_TYPE = {
    SALES_RETURN_WITH_BILL: 1,
    SALES_RETURN_WITHOUT_BILL: 2

}